import React, { useEffect, useState } from 'react';
import WordItem from './word-item';
import './index.scss';

import { rankingThirdWords } from '../utils';
import { getWord } from '@/pages/opinion/services';
import { initialUpperCase } from '@/pages/opinion/utils';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl } from 'react-intl';

export default function Component({
  title,
  subtitle,
  type,
  keepParams,
  keywordCorrelationFilter,
  selects,
  setSelects,
  position,
  language,
  handleWordClick,
  isEndCard = false,
}: {
  title: string;
  subtitle: string;
  type: string;
  keepParams: any;
  keywordCorrelationFilter: any;
  selects: any;
  setSelects: any;
  position: string;
  language: string;
  handleWordClick?: any;
  isEndCard?: boolean;
}) {
  const [data, setData] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(true);
  const [apiError, setApiError] = useState(false);

  const {
    edition_unified_id,
    id_type,
    entity_type,
    start_time,
    end_time,
    date_type,
    sentiment: sentiments,
    language: languages,
  } = keepParams;

  const { pos, distance, frequency, correlation } = keywordCorrelationFilter;
  const { formatMessage } = useIntl();
  const fetchData = async (init = false) => {
    if (!edition_unified_id) return;

    setLoading(true);

    let words: any = [];

    const params: any = {
      edition_unified_id,
      id_type,
      entity_type,
      start_time,
      end_time,
      date_type,
      sentiments,
      languages,
      top_n: 50,
      position,
      words,
      words_type: type, // head, second, third
    };

    if (type === 'second') {
      words = [selects['head'].word];
    }

    if (type === 'third') {
      words = [selects['head'].word, selects['second'].word];

      if (selects['second'].position === 'before') {
        words = words.reverse();
      }
    }

    params.words = words;

    if (pos !== 'all') params.pos = pos;
    else delete params.pos;
    if (distance !== 'all') params.distance = Number(distance);
    else delete params.distance;
    params.correlation = correlation !== '' ? correlation : -9999;
    if (params.frequency !== '') params.frequency = frequency;
    else delete params.frequency;

    try {
      const data = await getWord(params);

      setApiError(false);

      if (data && Array.isArray(data) && data.length > 0) {
        const filterData = data.filter((item) => !!item.word);

        if (filterData.length > 0) {
          setData(filterData);

          if (init) {
            setSelects({
              ...selects,
              head: filterData[0],
              second: { word: '' },
              third: { word: '' },
            });
          }

          setNoData(false);
        } else {
          setNoData(true);
        }
      } else {
        setNoData(true);
      }

      setLoading(false);
    } catch {
      setApiError(true);
      setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type === 'head') {
      fetchData(true);
    }
    setSelects({
      head: { word: '' },
      second: { word: '' },
      third: { word: '' },
    });
    setData([]);
  }, [keepParams, keywordCorrelationFilter]);

  useEffect(() => {
    console.log('change head', JSON.stringify(selects));

    if (!selects.head.word) return;

    if (type === 'second') {
      fetchData();
      setData([]);
    }

    if (type === 'third') {
      setData([]);
    }

    setSelects({
      ...selects,
      second: { word: '' },
      third: { word: '' },
    });
  }, [selects.head.word, position]);

  useEffect(() => {
    console.log('change second', JSON.stringify(selects));
    if (type === 'third') {
      if (selects.second.word) {
        setData([]);
        fetchData();
        setSelects({
          ...selects,
          third: { word: '' },
        });
      } else {
        setData([]);
        setSelects({
          ...selects,
          third: { word: '' },
        });
      }
    }
  }, [selects.second.word, selects.second.position]);

  const handleClick = (value, type) => {
    console.log('handleClick', value, type, selects);

    const newSelects = {
      ...selects,
      [type]: value,
    };
    if (type === 'head') {
      newSelects.second = { word: '' };
      newSelects.third = { word: '' };
    }

    if (type === 'second') {
      const { second } = selects;

      if (second.word === value.word && second.position === value.position) {
        newSelects.second = { word: '' };
      }

      newSelects.third = { word: '' };
    }

    if (type === 'third') {
      const { third } = selects;
      if (third.word === value.word && third.position === value.position) {
        newSelects.third = { word: '' };
      }
    }

    handleWordClick?.(value, type);

    setSelects(newSelects);
    // setSelects({
    //   ...selects,
    //   [type]: value,
    // });
  };

  const renderWord = (item) => {
    const maps = {
      origin: 'word',
      zh: 'word_cn',
      en: 'word_en',
    };

    const { position } = item;

    const key = maps[language] || maps.origin;

    let word = initialUpperCase(item[key]);

    if (type === 'second') {
      let words = [selects.head[key], word].map((item) =>
        initialUpperCase(item),
      );

      if (position === 'before') {
        words = words.reverse();
      }

      word = words.join(',');
    } else if (type === 'third') {
      let words = rankingThirdWords({
        head: selects.head,
        second: selects.second,
        third: item,
      }).map((item) => initialUpperCase(item[key]));
      word = words.join(',');
    }

    return word;
  };

  return (
    <CardCommon
      className="dbo-correlation-wordcard"
      title={
        <>
          {title}
          <span className="dbo-correlation-wordcard-subtitle">{subtitle}</span>
        </>
      }
      loading={loading}
      empty={apiError || noData || data?.length === 0}
      loadingHeight={340}
      emptyHeight={340}
      {...(isEndCard
        ? {
            emptyDescText: formatMessage({
              id: 'After selecting the First Correlation Words on the left, the corresponding Second Correlation Words will be displayed here.',
            }),
          }
        : {})}
    >
      <div className="dbo-correlation-wordcontent">
        {data.map((item) => {
          const { word, position } = selects[type];
          return (
            <WordItem
              {...item}
              type={type}
              text={renderWord(item)}
              active={item.word === word && item.position === position}
              handleClick={(value) => handleClick(value, type)}
            ></WordItem>
          );
        })}
      </div>
    </CardCommon>
  );
}
